import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';

export interface NativeSelectOption {
  value: string;
  label: string;
}

@Component({
  selector: 'app-edit-modal-native-select',
  standalone: true,
  template: `
    <select
      [attr.id]="selectId || null"
      [class]="selectClass"
      [value]="value ?? ''"
      (change)="onChange($event)"
    >
      @for (opt of options; track opt.value) {
      <option [value]="opt.value">{{ opt.label }}</option>
      }
    </select>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      :host {
        display: contents;
      }
    `,
  ],
})
export class EditModalNativeSelectComponent {
  @Input() selectId = '';
  @Input() selectClass = '';
  @Input() value: string | number | boolean | null | undefined = '';
  @Input() options: NativeSelectOption[] = [];
  @Output() valueChange = new EventEmitter<string>();

  onChange(event: Event): void {
    this.valueChange.emit((event.target as HTMLSelectElement).value);
  }
}
